import DefaultServiceProviderImage from "/assets/img/ic_upload_image.svg";

import './select-responsible-admin.modal.scss';

export default function SelectResponsibleAdminModal($scope, $q, $t, $alert, $auth, api, close) {
  'ngInject';

  $scope.selectResponsibleAdmin = {
    query: ''
  };

  $scope.autocomplete = (request) => {
    const deferred = $q.defer();
    const query = {
      email: request,
      activated: true,
      role: 'ADMIN',
      page: 0,
      size: 5
    };

    api.autocomplete(query,
      response => {
        response
          .filter(item => !item.avatar)
          .forEach(item => item.avatar = DefaultServiceProviderImage)
        deferred.resolve(response)
      },
      error => deferred.reject(error));

    return deferred.promise;
  }

  $scope.displayAdmin = item => {
    return item ? item.name + ' ' + item.surname : '';
  }

  $scope.assignToMe = () => {
    close($auth.user());
  }

  $scope.ok = (form) => {
    if (form.$valid) {
      if (!$scope.selectResponsibleAdmin.admin) {
        $alert.error($t('shared.modals.search_responsible_admin.select_admin_error_message'));
        return;
      }

      close({id: $scope.selectResponsibleAdmin.admin.id});
    }
  }

  $scope.close = () => {
    close(false);
  }
}